<template>
  <section class="promo__codes-form-wrap">
    <Modal
      v-model:show="active"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('promoCodes.addPromocodes.editPromocode') }}
        </h5>
      </template>

      <div>
        <form @keyup.enter="send">
          <UiInput
            v-model="form.promocode"
            class="mb-12"
            :label="$t('promoCodes.addPromocodes.promocode')"
            :placeholder="$t('promoCodes.addPromocodes.promocode')"
            disabled
          />
          <UiSelect
            v-model="offer"
            :label="$t('promoCodes.addPromocodes.offer')"
            :placeholder="$t('promoCodes.addPromocodes.selectOffer')"
            :list="offers"
            is-search
            class="mb-16"
          />
          <ElPopover
            ref="popover"
            v-model:visible="warningOpen"
            placement="top-end"
            trigger="click"
            width="320"
          >
            <p>{{ $t('promoCodes.addPromocodes.changeSubId') }}</p>
            <button
              class="btn btn-outline-primary btn-md"
              @click="warningOpen = false"
            >
              {{ $t('offerRequest.btnCancel') }}
            </button>
            <button
              class="btn btn-primary btn-md !tw-ml-1rem"
              @click="confirmChanges(); warningOpen = false"
            >
              {{ $t('offerRequest.btnConfirm') }}
            </button>
            <template v-slot:reference>
              <div />
            </template>
          </ElPopover>

          <UiSelect
            v-model="traffic_source_id"
            :label="$t('trafficSources.trafficSource')"
            :placeholder="$t('offerRequest.noTrafficSources')"
            :list="sources"
            class="mb-16"
            is-search
            @change="changeSource"
          />

          <div class="row row-wrap__subid">
            <div
              v-for="(item, i) in form.subids"
              :key="i"
              class="col-6 col-6__add-subid mb-12"
            >
              <UiInputSubid
                v-model="item.value"
                :label="`SubID ${form.subids.indexOf(item) + 1}`"
                :placeholder="$t('trafficSources.postbacks.notSpecified')"
                :can-delete="form.subids.indexOf(item) === form.subids.length - 1 && form.subids.length > 1"
                @delete="popSubIds"
              />
            </div>
            <div class="col-6 !tw-flex !tw-items-end col-6__add-subid mb-12">
              <button
                :disabled="form.subids.length >= 5"
                href="#"
                class="btn btn-block btn-outline-primary btn-sm mt-12 mb-0"
                @click.prevent="form.subids.length < 5 && addSubId()"
              >
                + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <template v-slot:footer>
        <div class="!tw-text-right !tw-flex !tw-items-baseline">
          <a
            class="btn btn-outline-primary btn-sm mb-4"
            @click="close"
          >
            {{ $t('promoCodes.addPromocodes.cancel') }}
          </a>
          <a
            class="btn btn-primary btn-sm !tw-ml-1rem"
            @click="send"
          >
            <span v-if="!$store.state.errors.loading">{{ $t('promoCodes.addPromocodes.send') }}</span>
            <i
              v-if="$store.state.errors.loading"
              class="fas fa-spinner spinner-hide"
            />
          </a>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  props: ['offsetParams'],
  data() {
    return {
      warningOpen: false,
      active: false,
      offer: '',
      id: '',
      changed: false,
      sending: false,
      traffic_source_id: '',
      oldTSid: '',
      form: {
        promocode: '',
        subids: [{ value: null }],
      },
    };
  },

  computed: {
    offers() {
      return this.$store.state.promocode.offers.map((e) => ({
        text: e.name,
        id: e.id,
      }));
    },
    sources() {
      return this.$store.state.trafficSource.list.map((e) => ({
        id: e.data.id,
        text: e.name,
      }))
        .concat({
          id: '',
          text: this.$t('offerRequest.noTrafficSources'),
        });
    },
  },
  activated() {
    this.$store.dispatch('getPromocodeOffersLazy');
  },

  watch: {
    traffic_source_id(value, oldValue) {
      this.oldTSid = oldValue;
    },
  },
  methods: {
    selectOffer(v) {
      this.offer = v.id;
    },
    changeSource(value) {
      if (!value) {
        // if no traffic source selected clear subids
        this.form.subids = [{ value: null }];
        return;
      }
      // subids from promocodes
      let promocodeSubIds = this.$store.state.promocode.promocodes.filter((e) => e.id === this.id)[0];
      promocodeSubIds = this.$_.pick(promocodeSubIds, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);

      // subids from ts
      let source = this.$store.state.trafficSource.list.filter((e) => e.data.id === value)[0];
      source = this.$_.pick(source, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);

      // subids from old ts
      let oldSource = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.oldValue)[0];
      oldSource = this.$_.pick(oldSource, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);

      // take current subids
      const subids = {};
      for (let i = 0; i < 5; i++) {
        const key = `subid${i + 1}`;
        subids[key] = this.form.subids[i] ? this.form.subids[i].value : null;
      }

      // if current subids is equal with subids from promocodes or trafficsources
      if (this.$_.isEqual(subids, oldSource)) {
        this.form.subids = [];
        this.addSubids(source);
      } else {
        // show warning
        this.warningOpen = true;
      }
      this.oldValue = value;
    },
    confirmChanges() {
      this.form.subids = [];
      const source = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.traffic_source_id)[0];
      this.addSubids(source);
    },
    addSubids(source) {
      if (!source) {
        this.form.subids = [{ value: null }];
        return;
      }
      this.form.subids = [];
      // Push subids
      Object.keys(source).map((k) => {
        if (k.startsWith('subid')) {
          const subid_index = parseInt(k.replace('subid', '')) - 1;
          if (source[k]) {
            this.form.subids.push({
              value: source[k],
            });
          } else {
            this.form.subids.push({
              value: null,
            });
          }
        }
      });
      // reduce subids
      for (let i = this.form.subids.length - 1; i >= 1; i--) {
        if (!this.form.subids[i].value) this.form.subids.pop();
        else break;
      }
    },

    async open(opts) {
      await this.$store.dispatch('getTrafficSources', {});
      this.offer = opts.affiliateOfferId;
      this.id = opts.id;
      this.form.promocode = opts.promo_code;
      this.traffic_source_id = opts.traffic_source_id;
      this.active = true;
      this.form.subids = opts.subids;
    },
    close() {
      this.form.subids = [{ value: null }];
      this.active = false;
      this.form.promocode = '';
      this.changed = false;
      this.traffic_source_id = '';
      this.offer = '';
      this.sending = false;
      this.warningOpen = false;
    },
    send() {
      this.sending = true;
      this.changed = true;
      if (!this.offer) {
        return;
      }

      const data = {
        traffic_source_id: this.traffic_source_id,
        affiliate_offer_id: this.offer,
        promo_code: this.form.promocode,
        status: 'active',
      };

      this.form.subids.forEach((cur, i) => {
        data[`subid${parseInt(i) + 1}`] = cur.value;
      });

      this.$store
        .dispatch('putPromocode', { id: this.id, opts: data })
        .then((res) => {
          this.close();
          this.$store.dispatch('getPromocodesLazy', { ...this.offsetParams });
          this.$alert.success(this.$t('promoCodes.alerts.wasUpdated'));
        })
        .catch((err) => {
          this.$alert.error(this.$t('promoCodes.alerts.couldntCreate'));
        });
    },

    addSubId() {
      this.form.subids.push({
        value: null,
      });
    },
    popSubIds(item) {
      this.form.subids.pop();
    },
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/promocodes/addpromocode';
</style>
